import * as React from 'react';
import { withOnlyCurrentItem } from '../../decorators/selectors';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { uploadDefaultDropActionHandler } from './handlers/upload';
import { defaultDropActionControl } from '../../../controls/defaultDropActionControl';
import { IActionInput, ISelectedActionProps, ActionSelector } from '../../withAction/WithAction';
import { connectToItemCache } from '../../decorators/connectToItemCache';

/**
 * @public
 */
export interface IDefaultDropActionHandlerProps {
    itemKey: string;
}

/**
 * @public
 */
export interface IDefaultDropActionHandler {
    key: string;
    evaluate(itemCache: IItemCache, props: IDefaultDropActionHandlerProps): {
        action?: IActionInput;
    };
}

const HANDLERS: IDefaultDropActionHandler[] = [uploadDefaultDropActionHandler];

/**
 * @public
 */
export interface IItemDefaultDropActionProps {
    itemKey: string | undefined;
}

/**
 * Component which provides a 'defualt drop' action for an item, which is typically Upload.
 * @public
 */
export const ItemDefaultDropAction: React.ComponentType<IItemDefaultDropActionProps> = connectToItemCache((
    itemCache: IItemCache,
    props: IItemDefaultDropActionProps
): ISelectedActionProps => {
    const {
        itemKey
    } = props;

    if (!itemKey) {
        return {
            action: null
        };
    }

    const controlHandler = itemCache.demandItemFacet(defaultDropActionControl, itemKey);

    const {
        handlers
    } = defaultDropActionControl.evaluate(controlHandler)(itemCache, {
        itemKey: itemKey,
        handlers: HANDLERS
    });

    let HandlerAction: IActionInput | undefined;

    for (const handler of handlers) {
        const {
            action: handlerAction
        } = handler.evaluate(itemCache, {
            itemKey: itemKey
        });

        if (handlerAction) {
            HandlerAction = handlerAction;
            break;
        }
    }

    return {
        action: HandlerAction
    };
})(ActionSelector);

/**
 * @public
 */
export const DefaultDropAction = withOnlyCurrentItem()(ItemDefaultDropAction);
